import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    VStack,
    Text,
} from "@chakra-ui/react";

const SessionExpiredModal = ({ open, onLogin }) => {
    return (
        <Modal
            isOpen={open}
            onClose={() => {}}
            closeOnEsc={false}
            closeOnOverlayClick={false}
            isCentered
            size="md"
        >
            <ModalOverlay
                bg="blackAlpha.600"
                backdropFilter="blur(4px)"
            />

            <ModalContent
                maxW="460px"
                w="calc(100% - 32px)"
                mx="auto"
                my="auto"
                bg="#F1F5F9"
                border="1px solid"
                borderColor="#E2E8F0"
                borderRadius="20px"
                p={4}
                boxShadow="0 20px 60px rgba(7, 29, 84, 0.25)"
            >
                <ModalBody py={12} px={8}>
                    <VStack
                        spacing={5}
                        textAlign="center"
                        align="stretch"
                    >
                        <Text
                            fontSize="20px"
                            fontWeight="700"
                            color="#071D54"
                        >
                            Session Expired
                        </Text>

                        <Text
                            color="gray.600"
                            fontSize="15px"
                            lineHeight="1.7"
                        >
                            Your session has expired for security
                            reasons. Please sign in again to
                            continue using Mogoma Admin Dashboard.
                        </Text>

                        <Button
                            bg="#071D54"
                            color="white"
                            w="100%"
                            h="38px"
                            borderRadius="12px"
                            fontSize={"14px"}
                            fontWeight="500"
                            _hover={{
                                bg: "#0B2A70",
                                transform: "translateY(-1px)",
                            }}
                            _active={{
                                bg: "#06163F",
                                transform: "translateY(0)",
                            }}
                            onClick={onLogin}
                        >
                            Login Again
                        </Button>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default SessionExpiredModal;